import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from 'react';
const TableContext = createContext({ compact: false });
export const useTableContext = () => useContext(TableContext);
export const TableProvider = ({ compact, children }) => {
    const value = useMemo(() => ({ compact: !!compact }), [compact]);
    return _jsx(TableContext.Provider, { value: value, children: children });
};
